import Box from 'UIKit/Box/Box'
import { BoxProps } from 'UIKit/Box/types'
import Text from 'UIKit/Text'
import { UserBonus } from 'config/types/bonus/userBonus'
import Column from 'layout/Components/Column'
import React from 'react'
import { Trans } from 'react-i18next'
import { useDisplayBonusName } from 'views/BonusCenter/hooks'

const BonusItemName: React.FC<{ bonus: UserBonus } & BoxProps> = ({ bonus, ...props }) => {
  const [name] = useDisplayBonusName(bonus.info?.name)

  return (
    <Box {...props}>
      <Column>
        {bonus.info?.badge && (
          <Text
            color="textSubtle"
            fontSize="12px"
            fontWeight={400}
            lineHeight="normal"
            letterSpacing={-0.24}
            ellipsis={1}
            wordBreak="break-all"
          >
            <Trans>{bonus.info.badge}</Trans>
          </Text>
        )}

        <Text
          fontSize="16px"
          lineHeight="normal"
          letterSpacing={-0.32}
          fontWeight={700}
          ellipsis={1}
          wordBreak="break-all"
        >
          {name}
        </Text>
      </Column>
    </Box>
  )
}

export default BonusItemName
